
 
<div>
    <p-checkbox label="Use Map for search." (onChange)="mapGeomCbxChanged()"  [(ngModel)]='useMapGeometryCbx' binary="true"></p-checkbox>


    <div *ngIf="useMapGeometryCbx">
        <p-radioButton label="Map Extent" value="extent" name="mapGeometry"   (click)="searchTypeChanged()" binary="true" [(ngModel)]="mapGeometryRadBx"></p-radioButton>
        <p-radioButton label="Draw on Map" value="graphic" name="mapGeometry" (click)="searchTypeChanged()" [(ngModel)]="mapGeometryRadBx"></p-radioButton>
    </div>
 </div>
 <div #mapViewNode class="app-map-view">
        <!-- <div id="poly-button" class="esri-widget esri-widget--button esri-interactive" title="Draw polygon">
        <span  class="esri-icon-polygon"></span>
      </div> -->
 </div>
